'use client'

import { ConversationMessageType } from '@marketplace-web/messaging/conversation-messaging-data'
import { OfferMessage } from '@marketplace-web/offers/price-offers-data'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import { isOfferMessage } from '../utils/price-offers'

const useGetPendingSellerOfferMessage = (): OfferMessage | null => {
  const { conversation } = useConversationContext()

  const pendingSellerOfferMessage = conversation?.messages?.find(
    message =>
      isOfferMessage(message.message) &&
      message.message.isCurrentOffer &&
      message.entityType === ConversationMessageType.OfferMessage,
  )?.message

  return pendingSellerOfferMessage && isOfferMessage(pendingSellerOfferMessage)
    ? pendingSellerOfferMessage
    : null
}

export default useGetPendingSellerOfferMessage
